<template>
  <modal v-model="value.show">
    <div slot="content">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="ls-modal-header">
          <button type="button" close-modal data-dismiss="modal">&times;</button>
          <h4 class="ls-modal-title">{{ $t('contracts.change_corp_due_date.title') }}</h4>
        </div>

        <div class="ls-modal-body">
          <label class="ls-label" :class="{'ls-error': errors.has($t('contracts.send_payment_url.due_date')) }">
            <b class="ls-label-text">{{ $t('contracts.send_payment_url.due_date') }}</b>
            <input
              type="date"
              v-model="anotherCorpDueDate"
              v-validate="'required|date'"
              :name="$t('contracts.send_payment_url.due_date')" />
            <small class="ls-help-message" v-show="errors.has($t('contracts.send_payment_url.due_date'))">{{ errors.first($t('contracts.send_payment_url.due_date')) }}</small>
          </label>
        </div>
        <div class="ls-modal-footer">
          <button type="button" class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
          <button type="submit" class="ls-btn ls-btn-primary ls-float-right">{{ $t('application.button.confirm') }}</button>
        </div>
      </form>
    </div>
  </modal>
</template>
<script type="text/javascript">
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Modal from 'src/app/components/shareds/modal/Modal'
  import date from 'src/utils/date'
  import scroll from 'src/utils/scroll'

  export default {
    props: ['value'],
    components: { Modal },
    data () {
      return {
        anotherCorpDueDate: date
      }
    },
    computed: {
      ...mapGetters(['invoice', 'invoices', 'contract'])
    },
    methods: {
      ...mapActions(['updateCorpDueDateInvoice']),
      ...mapMutations(['clearFlash']),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.afterValidate)
      },
      afterValidate (success) {
        if (!success) return
        this.value.show = false
        this.$loader.show()
        this.clearFlash()
        let params = { invoice_id: this.invoice.id, corp_due_date: this.anotherCorpDueDate, index: this.value.index }
        this.updateCorpDueDateInvoice(params).then(this.afterUpdate)
      },
      afterUpdate (response) {
        if (response && response.status === 200) {
          scroll.scrollToFlash()
          this.$loader.hide()
        }
      },
      loadData () {
        this.$loader.show()
        this.fillDate()
        this.$loader.hide()
        scroll.scrollToFlash()
      },
      fillDate () {
        var corpDueDate = date.parseInternationalDate(this.invoice.due_date)
        var dateCurrent = date.parseInternationalDate(new Date())

        if (dateCurrent > corpDueDate) {
          this.anotherCorpDueDate = dateCurrent
        } else {
          this.anotherCorpDueDate = corpDueDate
        }
      }
    },
    mounted () {
      this.loadData()
    }
  }
</script>



// WEBPACK FOOTER //
// ModalChangeCorpDueDate.vue?38c0451c